var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2059 4.80013C2.20592 2.92237 3.72814 1.40015 5.6059 1.40015H16.4062C18.2839 1.40015 19.8062 2.92238 19.8062 4.80015V11.4001C19.8062 11.9524 19.3585 12.4001 18.8062 12.4001C18.2539 12.4001 17.8062 11.9524 17.8062 11.4001V4.80015C17.8062 4.02695 17.1794 3.40015 16.4062 3.40015H5.6059C4.83271 3.40015 4.20591 4.02694 4.2059 4.80014L4.20581 19.2001C4.20581 19.9733 4.8326 20.6001 5.6058 20.6001H10.4058C10.9581 20.6001 11.4058 21.0478 11.4058 21.6001C11.4058 22.1524 10.9581 22.6001 10.4058 22.6001H5.6058C3.72803 22.6001 2.2058 21.0778 2.20581 19.2001L2.2059 4.80013ZM17.3999 13.4001C17.9522 13.4001 18.3999 13.8479 18.3999 14.4001V16.7943L20.794 16.7943C21.3463 16.7943 21.794 17.242 21.794 17.7943C21.794 18.3465 21.3463 18.7943 20.794 18.7943H18.3999V21.1884C18.3999 21.7407 17.9522 22.1884 17.3999 22.1884C16.8477 22.1884 16.3999 21.7407 16.3999 21.1884V18.7943H14.0058C13.4535 18.7943 13.0058 18.3465 13.0058 17.7943C13.0058 17.242 13.4535 16.7943 14.0058 16.7943L16.3999 16.7943V14.4001C16.3999 13.8479 16.8477 13.4001 17.3999 13.4001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReport);
export default __webpack_public_path__ + "static/media/newReport.22156fd533a6788349f77a44fe6c9f17.svg";
export { ForwardRef as ReactComponent };